import * as React from "react";
import AzureCredentialsFieldGroup, {
  validateAzureCredentialsFields
} from "data-tiering/repository-management/AzureCredentialsFieldGroup";
import AzureRepositorySetupInfo from "data-tiering/repository-management/AzureRepositorySetupInfo";
import { AZURE_AUTH_MODE } from "data-tiering/repository-management/types";
import AzureCredentialsFormFields, {
  validateAzureCredentialsForm
} from "data-tiering/warm-tier-repositories/AzureCredentialsFormFields";
const AzureEditFields = ({ record }) => {
  var _a;
  return /* @__PURE__ */ React.createElement(AzureCredentialsFormFields, { keyIsSet: !!((_a = record == null ? void 0 : record.account_key) == null ? void 0 : _a.is_set) });
};
const initialEditValues = (stored) => {
  var _a, _b, _c;
  const record = stored;
  return record ? {
    auth_mode: record.auth_mode,
    account_name: (_a = record.account_name) != null ? _a : void 0,
    account_key: ((_b = record.account_key) == null ? void 0 : _b.is_set) ? { keep_value: true } : void 0,
    endpoint_uri: (_c = record.endpoint_uri) != null ? _c : void 0
  } : { auth_mode: "automatic" };
};
const toUpdatePayload = (values) => {
  var _a, _b;
  return {
    type: "azure",
    auth_mode: values.auth_mode,
    account_name: (_a = values.account_name) != null ? _a : null,
    account_key: values.auth_mode === "account_key" ? values.account_key : void 0,
    endpoint_uri: (_b = values.endpoint_uri) != null ? _b : null
  };
};
const azureDefinition = {
  create: {
    initialValues: () => ({
      type: "azure",
      auth_mode: AZURE_AUTH_MODE.AUTOMATIC,
      account_name: void 0,
      account_key: void 0,
      endpoint_uri: void 0
    }),
    validate: (credentials) => validateAzureCredentialsFields(credentials),
    Fields: AzureCredentialsFieldGroup,
    SetupInfo: AzureRepositorySetupInfo
  },
  edit: {
    initialValues: initialEditValues,
    validate: (values) => validateAzureCredentialsForm(values),
    toPayload: (values) => toUpdatePayload(values),
    Fields: AzureEditFields
  }
};
export default azureDefinition;
